// extracted by mini-css-extract-plugin
export default {"middleColumn":"login-panel_middleColumn__SfbWB","headerText":"login-panel_headerText__CLqIQ","indent":"login-panel_indent__pb08P","indent_second":"login-panel_indent_second__E6vTS"};